// 이전 SW 가 앱 전체 정적 자원(≈73MB)을 precache 하고 모든 요청을 cache-first 로 처리해
// 첫 방문 로딩 대역폭을 잠식했다. 등록을 중단하고 기존 설치와 캐시를 정리한다.
// 옛 SW 가 제어 중이라 이 새 JS 를 못 받는 클라이언트는 public/service-worker.js 가 정리한다.
// 기존 사용자가 충분히 정리된 뒤(한 배포 주기 이상) 이 호출과 public/service-worker.js 를 지운다.
export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    })
    .catch(() => {});
  if ("caches" in window) {
    caches
      .keys()
      .then((keys) => keys.forEach((key) => caches.delete(key)))
      .catch(() => {});
  }
}
